import React, {useState, Suspense} from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import UISunEditor from "components/wysiwygeditor/UISunEditor";
import PageLoading from "../../../../components/loading";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import StringUtil from "../../../../utils/StringUtil";
import UISelect from "../../../../components/selectbox/UISelect";
import UIUtils from "utils/UIUtils";
import CodeDataStore from "common/codedata/store/CodeDataStore";

function ContentsContainer() {
	const history = useHistory();
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const demandNo = receivedData?.DEMAND_NO;
	const seq = receivedData?.SEQ;

	// 파일
	const [fileValue] = useState(new TbComFile());
	const [reqFileValue] = useState(new TbComFile());
	const [loadFinish,setLoadFinish] = useState(false);
	const [reqFileNm, setReqFileNm] = useState('');

	const [bizNm, setBizNm] = useState('');
	const [personNm, setPersonNm] = useState('');
	const [posiNm, setPosiNm] = useState('');
	const [ofcTelNo, setOfcTelNo] = useState('');
	const [hpNo, setHpNo] = useState('');
	const [emailAdres, setEmailAdres] = useState('');
	const [emailId ,setEmailId] = useState('');
	const [emailDomain, setEmailDomain] = useState('');
	const [emailSelect, setEmailSelect] = useState('');
	const [emailList,setEmailList] = useState<any[]>([]);
	let currentDate = DateUtil.toDateFormat(new Date, "YYYY-MM-DD");
	const [bizNo, setBizNo] = useState('');
	const [reqDate, setReqDate] = useState('');
	const [personId, setPersonId] = useState('');
	const [deptNm, setDeptNm] = useState('');
	const [corpNm, setCorpNm] = useState('');
	const [title, setTitle] = useState('');

	const [reqTitle, setReqTitle] = useState('');
	const [funUseYn, setFunUseYn] = useState('Y');
	const [funUseAmt, setFunUSeAmt] = useState(0);
	const [fileId, setFileId] = useState('');

	// 폼체크 여부
	const [formCheck,setFormCheck] = useState(false);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [reqUploadId, setReqUploadId] = React.useState("");
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const onCreationComplete = function (uploadID: string) {
		setUploadId(uploadID);
	}

	//파일업로드 완료
	const onUploadComplete = (type) => {
		const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
		const arrayNew = dataArray.newFile;
		const arrayDel = dataArray.deleteFile;
		console.log(JSON.stringify(arrayNew));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					FILE_DETAIL_ID:item.uniqKey,
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:type,
					FILE_STATUS:"ADD"
				}

				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_GB:type,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);

		})
		setFileInfoList(fileInfos);

	}

	const onFileUpload = () => {
		if(uploadId){
			window["RAONKUPLOAD"].Transfer(uploadId);
		}
		setFormCheck(true);
	}

	/**
	 * 파일업로드 팝업
	 */
	const reqModal = () => {
		let title = '필수서류 첨부';

		if(reqFileNm != ''){
			UIUtils.alert('파일 삭제 후 진행해주세요').then();
			return;
		}

		UIUtils.openFileUploadPopup({
			title: title,
			buttonTitle: "등록",
			attrs: {
				MaxTotalFileCount: "1",
				ExtensionAllowOrLimit: "1",
			},
			valueChanged: async data => {
				console.log("fileId uploadId : "+ reqUploadId);
				// @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
					const dataArray = window["RAONKUPLOAD"].GetListInfo('array', reqUploadId);
					const arrayNew = dataArray.newFile;
					const arrayDel = dataArray.deleteFile;
					console.log("arrayNew", JSON.stringify(arrayNew));

					let fileInfos : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					}[] = [];

					let fileInfo : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					};



					// @ts-ignore
					let item = data.tbComFileMapngDetailList[0];

					// @ts-ignore
					let uniqKey = item.uniqKey;
					// @ts-ignore
					let orginlFileNm = item.orginlFileNm;
					// @ts-ignore
					let streFileNm = item.streFileNm;
					// @ts-ignore
					let fileSize = item.fileSize;
					// @ts-ignore
					let strePath = item.strePath;
					// @ts-ignore
					let fileExtsn = item.fileExtsn;

					//파일등록 정보
					fileInfo = {
						FILE_DETAIL_ID:uniqKey,
						ORGINL_FILE_NM:orginlFileNm,
						STRE_FILE_NM:streFileNm,
						FILE_SIZE:fileSize,
						STRE_PATH: strePath,
						FILE_EXTSN:fileExtsn,
						FILE_GB:"REQ",
						FILE_STATUS:"ADD"
					}
					// @ts-ignore
					setReqFileNm(orginlFileNm);


					fileInfos.push(fileInfo);
					// console.log(fileInfoListPop);
					setFileInfoListPop(fileInfoListPop.concat(fileInfos));
				}


			}
		})

	}

	async function fileDelete(){

		let item ;
		if(reqFileValue.tbComFileMapngDetailList.length != 0){
			// @ts-ignore
			item = reqFileValue.tbComFileMapngDetailList[0];
		}

		// console.log(item);

		if(item == undefined && fileInfoListPop.filter(a => a.FILE_GB == "REQ").length != 0){
			let newList = [...fileInfoListPop];
			newList = newList.filter(a => a.FILE_GB != "REQ")
			setFileInfoListPop(newList);
			UIUtils.alert('삭제 되었습니다.').then();
			// @ts-ignore
			setReqFileNm('');
			return;
		}else if(item == undefined){
			UIUtils.alert('삭제 할 파일이 없습니다.').then();
			return;
		}

		if(item == undefined){
			UIUtils.alert('삭제 할 파일이 없습니다.').then();
			return;
		}

		if(await UIUtils.confirm('삭제하시겠습니까?')){

			setReqFileNm('');

			let fileInfos : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			}[] = [];

			let fileInfo : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			};



			// @ts-ignore
			let uniqKey = item.fileDetailId;
			// @ts-ignore
			let orginlFileNm = item.orginlFileNm;
			// @ts-ignore
			let streFileNm = item.streFileNm;
			// @ts-ignore
			let fileSize = item.fileSize;
			// @ts-ignore
			let strePath = item.strePath;
			// @ts-ignore
			let fileExtsn = item.fileExtsn;

			//파일등록 정보
			fileInfo = {
				FILE_DETAIL_ID:uniqKey,
				ORGINL_FILE_NM:orginlFileNm,
				STRE_FILE_NM:streFileNm,
				FILE_SIZE:fileSize,
				STRE_PATH: strePath,
				FILE_EXTSN:fileExtsn,
				FILE_GB:"REQ",
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			let newList = [...fileInfoListPop];
			setFileInfoListPop(newList.concat(fileInfos));
		}

	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	async function getRead() {

		const response:any = await CommonUtil.execute({
			url: 'usr_1909',
			data: {DEMAND_NO: demandNo,
					SEQ: seq,
			}
		}).then((response: any) => {
			setBizNm(response.BIZ_NM);
			setPosiNm(response.POSI_NM);
			setPersonNm(response.PERSON_NM);
			setOfcTelNo(response.OFC_TEL_NO);
			setHpNo(response.HP_NO);
			let emailAdres:string = response.EMAIL_ADRES;
			setEmailId(emailAdres.substring(0, emailAdres.indexOf('@')));
			setEmailDomain(emailAdres.substring(emailAdres.lastIndexOf('@') +1));
			setReqTitle(response.REQ_TITLE);
			setFunUseYn(response.FUN_USE_YN);
			setFunUSeAmt(response.FUN_USE_AMT);
			setReqDate(dateToStr(response.REQ_DATE));
			setFileId(response.FILE_ID);
			setPersonId(response.REQ_USERID);
			setDeptNm(response.DEPT_NM);
			setCorpNm(response.CORP_NM);
			setTitle(response.TITLE);

			fileValue.setTbComFileMapngDetailList([]);
			reqFileValue.setTbComFileMapngDetailList([]);
			let fileList = response.FILE_INFO;
			for(let i = 0; i < fileList.length; i++){
				if(fileList[i].FILE_GB == 'FILE'){
					let fileInfo = fileList[i];

					//파일등록 정보
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(fileInfo.DWLD_ID);
					fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
					fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
					fileDetail.setStrePath(fileInfo.STRE_PATH);
					fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
					fileDetail.setFileSize(fileInfo.FILE_SIZE);
					fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
					fileDetail.setRegistDt(fileInfo.REGIST_DT);
					fileValue.putTbComFileMapngDetailList(fileDetail);
				} else if(fileList[i].FILE_GB == 'REQ'){
					let fileInfo = fileList[i];

					//파일등록 정보
					const fileDetail = new TbComFileMapngDetail();
					fileDetail.setDwldId(fileInfo.DWLD_ID);
					fileDetail.setFileDetailId(fileInfo.FILE_DETAIL_ID);
					fileDetail.setFilePolicy(fileInfo.FILE_POLICY);
					fileDetail.setFileRpstr(fileInfo.FILE_RPSTR);
					fileDetail.setStrePath(fileInfo.STRE_PATH);
					fileDetail.setStreFileNm(fileInfo.STRE_FILE_NM);
					fileDetail.setOrginlFileNm(fileInfo.ORGINL_FILE_NM);
					fileDetail.setFileExtsn(fileInfo.FILE_EXTSN);
					fileDetail.setFileSize(fileInfo.FILE_SIZE);
					fileDetail.setRegistPsnNm(fileInfo.REGIST_PSN_NM);
					fileDetail.setRegistDt(fileInfo.REGIST_DT);
					reqFileValue.putTbComFileMapngDetailList(fileDetail);
					setReqFileNm(fileInfo.ORGINL_FILE_NM);
				}
			}

			setLoadFinish(true);
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});
	}

	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		let val = event.target.value;
		//여기
		setFunUseYn(val);
		if(val === 'N') {
            setFunUSeAmt(0);
        } 
	};

	// 팝업 파일 업로드
	async function reqFormCheck() {

		// 필수값 체크
		if(corpNm == '' || personNm == '' || posiNm == '' || ofcTelNo == '' || emailId == '' || emailDomain == '' || reqTitle == ''){
			await UIUtils.alert("필수입력이 완료되지 않았습니다.\n 다시 확인해 주세요.").then();
			return;
		}

		if(reqFileNm == ''){
			await UIUtils.alert("필수입력이 완료되지 않았습니다.\n 다시 확인해 주세요.").then();
			return;
		}


		if(await UIUtils.confirm('저장하시겠습니까?')){

			setFormCheck(true);
			// 파일 업로드
			await onFileUpload();
		}

	}

	async function reqEdit(sendParam:any){

		const response:any = await CommonUtil.execute({
			url:"usr_1910",
			data: sendParam
		}).then((response: any) => {
			UIUtils.alert("저장되었습니다.").then();
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});

		// 완료 후 상세화면으로 이동
		let dataToSend = { DEMAND_NO: demandNo, SEQ: seq};
		history.push({
			pathname: './usr_1909',
			state: { data: dataToSend }
		});

	};

	// 파일 업로드 성공여부 체크
	React.useEffect(() => {
		if(fileInfoList && formCheck) {
			// 파일 업로드 성공
			let param ={
				BIZ_NM : bizNm,
				PERSON_ID : personId,
				PERSON_NM : personNm,
				POSI_NM : posiNm,
				DEPT_NM : deptNm,
				OFC_TEL_NO : ofcTelNo,
				HP_NO : hpNo,
				EMAIL_ADRES : emailId + '@' + emailDomain,
				DEMAND_NO : demandNo,
				REQ_TITLE : reqTitle,
				SEQ : seq,
				BIZ_NO : bizNo,
				FUN_USE_YN : funUseYn,
				FUN_USE_AMT : funUseAmt,
				FILE_ID : fileId,
				REQ_INFO_LIST:fileInfoListPop,
				FILE_INFO_LIST:fileInfoList.concat(fileInfoListPop),
			}

			console.log("param : "+JSON.stringify(param));

			//내용 저장
			reqEdit(param);

		}
	}, [fileInfoList])


	React.useEffect(() => {
		getRead();

		//필요한 공통코드 로딩.
		CodeDataStore.read("/common/useYn", "[EVC]", "[EVDC]", "[SCS]", "[INC]", "[EFC]", "[EMAIL]")
		.then(() => {
			let email = CodeDataStore.get("[EMAIL]");
			setEmailList(email);
		});
	}, []);//effect

	// 이전 이동
	async function onClickDetail(event) {
		event.preventDefault();
		let dataToSend = {DEMAND_NO : demandNo , SEQ : seq};
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_1909',
			state: { data: dataToSend }
		});

	};


	return (
		<PageContainer session={false}>
			<LayoutAside />
			<div className='fww-con'>
				<ul className="fww-brd">
					<li><Link to="/main/">홈</Link></li>
					<li><Link to="#">상생협력기금안내</Link></li>
					<li><Link to="#">수요조사</Link></li>
				</ul>
				<main className="fww-main" data-layout="usr">
					<h1 className="tx tx-hd2">수요조사 지원 내용 수정</h1>
					<section className="fund-section">
						<div className="hz-root hz-gap10 hz-sb mb15">
							<h3 className="section-title">기본정보</h3>
							<p className="tx-msg"><span className="fc-pri">*</span>&nbsp;필수 입력</p>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item req">
									<p className="fo-key">수요조사지원일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={reqDate} placeholder={''} readOnly={true} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">신청기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={'기업명을 입력하세요.'} readOnly={true} valueChanged={(value) => setCorpNm(value)}/>
									</div>
								</div>
								
								<div className="fo-item req">
									<p className="fo-key">담당자명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={'담당자명을 입력하세요'} readOnly={true} valueChanged={(value) => setPersonNm(value)}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">직함</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={'직함을 입력하세요'} readOnly={true} valueChanged={(value) => setPosiNm(value)}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">연락처</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={ofcTelNo} placeholder={'연락처를 입력하세요(- 생략)'}  readOnly={true} valueChanged={(value) => setOfcTelNo(value)}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">휴대폰번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={hpNo} placeholder={'휴대폰번호를 입력하세요(- 생략)'} readOnly={true} valueChanged={(value) => setHpNo(value)}/>
									</div>
								</div>
								<div className="fo-item  fo-m-1-3 req">
									<p className="fo-key">이메일주소</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w565">
											<UIInput
												className={'hz-item hz-fg tf tf-md'}
												rules={["required"]}
												value={emailId}
												readOnly={true}
												placeholder={'메일계정 입력'}
												//valueChanged={(value) => setEmailId(value)}
											/>
											<span>@</span>
											<UIInput
												className={'hz-item hz-fg tf tf-md'}
												rules={["required"]}
												value={emailDomain}
												readOnly={true}
												//valueChanged={(value) => setEmailDomain(value)}
												//attrs={{ readOnly: StringUtil.isNotEmpty(emailSelect), placeholder: "이메일 주소를 입력해주세요." }}
											/>
											{/*<div className="hz-item hz-fg sl sl-md">
												<UISelect
													className={'hz-item hz-fg tf tf-md'}
													value={emailSelect}
													valueChanged={(value) => {
														if (StringUtil.isNotEmpty(value)) {
															setEmailDomain(value);
															setEmailSelect(value);
														} else {
															setEmailDomain("");
															setEmailSelect("");
														}
														setEmailDomain(value);
													}}
													codeData={emailList}
													firstName={"write"}
												/>
											</div>*/}
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">신청 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="innter">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">신청제목</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={reqTitle} placeholder={'신청제목을 입력하세요.'} valueChanged={(value) => setReqTitle(value)}/>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<p className="fo-key">상생협력기금 사용여부</p>
									<div className="fo-value">
										<div className="hz-root hz-gap15">
											<label htmlFor="ch-1" className="hz-item ip-ch-label ip-ch-18">
												<input id="ch-1" className="ip-ch" type="checkbox" value='Y'
													   checked={funUseYn == 'Y'} onChange={handleOptionChange}/>
												<span className="check"></span>
												<span className="txt">사용</span>
											</label>
											<label htmlFor="ch-2" className="hz-item ip-ch-label ip-ch-18">
												<input id="ch-2" className="ip-ch" type="checkbox" value='N'
													   checked={funUseYn == 'N'} onChange={handleOptionChange}/>
												<span className="check"></span>
												<span className="txt">미사용</span>
											</label>
										</div>
									</div>
								</div>
								{funUseYn == 'Y' &&
									<div className="fo-item fo-m-1-3">
										<p className="fo-key">금액입력(원)</p>
										<div className="fo-value">
											<div className="fund-form-items tf-unit">
												<UIInput className={'tf tf-md ta-right'} value={Number(funUseAmt)} placeholder={'상생협력기금으로 사용할 금액을 입력하세요.'} valueChanged={(value) => setFunUSeAmt(value)} />
												<span className="u">원</span>
											</div>
										</div>
									</div>
								}
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">첨부파일</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="innter">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">필수서류</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items">
												<div className="hz-root hz-gap5 w100p mr30">
													<UIInput className={'tf tf-md hz-item grow'} value={reqFileNm}
															 placeholder={'신청서 업로드(필수)'}/>
													<div className="hz-root hz-gap5 w120 ">
														<Button color='pri-o2' size="md"
																onClick={() => reqModal()}>찾기</Button>
														<Button color='gray-o' size="md"
																onClick={() => fileDelete()}>삭제</Button>
													</div>
												</div>
											</div>
											<Button color='gray-o' size="md">양식 다운로드</Button>
										</div>
									</div>
								</div>

								<div className="fo-item fo-m-1-3">
									<div className="fo-value">
										<div className='w100p'>
											<UI.FileUpload
												onCreationComplete={onCreationComplete}
												onUploadComplete={() => onUploadComplete('FILE')}
												attrs={{
													ImgPreView: "99"
												}}
												value={fileValue}
											/>
										</div>
									</div>
								</div>

							</div>
						</form>
					</section>
					<div className="fww-signature">
						<span>{title} 공고문을 확인하고, 위와 같이 신청서를 제출합니다.</span>
						<strong>대·중소기업·농어업협력재단 사무총장 귀하</strong>
					</div>
					<div className="hz-root hz-center hz-gap10">
						<Button color="gray-o" size="big" onClick={onClickDetail}>취소</Button>
						<Button color="pri" size="big" onClick={reqFormCheck}>저장</Button>
					</div>
				</main>
			</div>
		</PageContainer>
);
}
export default ContentsContainer;